import cookie from 'js-cookie';

export const getCookie = cname => cookie.get(cname);

export const removeCookie = key => {
  if (process.browser) {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

export const setCookie = (key, value, expires) => {
  if (process.browser) {
    cookie.set(key, value, {
      expires,
      path: '/',
    });
  }
};
